import {Component, OnInit, ViewChild} from '@angular/core';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Company} from 'shared/models/target-groups/company';
import FileSaver from 'file-saver';
import {CompaniesService} from './services/companies.service';
import { TARGETGROUP_DUMMIES } from 'shared/models/target-groups/target-group';

@Component({
  selector: 'companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css'],
})

export class CompaniesComponent implements OnInit {
  public allCompanies: Array<Company> = [];
  public allCompaniesUsersCnt: Dictionary<number> = {};
  public filteredCompanies: Array<Company>;
  public fieldsToSearch: Array<Array<string>> = [];
  public newCompanyName: string;
  public searchTerm: string;
  public currentPage: Event;
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(
    private companiesService: CompaniesService
  ) { }

  public ngOnInit(): void {
    this.getAllCompanies();
  }

  private showDeleteModal(id: number): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie diese Firma löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public getAllCompanies(): void {
    this.companiesService.getAllCompanies()
      .subscribe((allCompanies: Array<Company>) => {
        this.allCompanies = allCompanies.filter((company) => { return !TARGETGROUP_DUMMIES.includes(company.name); });/*.map(company => {
          if ( company['leaderLinking'] === undefined ) {
            company.leaderLinking = 0;
          }
          return company;
        });*/
        this.filteredCompanies = allCompanies.filter((company) => { return !TARGETGROUP_DUMMIES.includes(company.name); });
        this.prepareFieldsToSearch();
      });
    this.companiesService.getAllCompaniesUsersCnt()
      .subscribe((allCompaniesUsersCnt: Array<any>) => {
        this.allCompaniesUsersCnt = {};
        allCompaniesUsersCnt
          .filter(a => a._id.company != null)
          .forEach(a => {
            this.allCompaniesUsersCnt[a._id.company] = a.count;
          });
      });
  }

  public createCompany(): void {
    // check if name already exists
    const old = this.allCompanies.filter(company => company.name.toLowerCase() === this.newCompanyName.toLowerCase());
    if ( old.length > 0 ) {
      alert("Der Name '" + old[0].name + "' wird bereits verwendet.");
      return;
    }
    this.companiesService.createCompany(this.newCompanyName)
      .subscribe((createdCompany: Company) => {
        this.getAllCompanies();
      });
  }

  public updateCompany(company: Company): void {
    this.companiesService.updateCompany(company)
      .subscribe((updatedCompany: Company) => {
        this.getAllCompanies();
      });
  }

  public deleteCompany(company: Company): void {
    this.companiesService.deleteCompany(company)
      .subscribe((response: boolean) => {
        this.getAllCompanies();
      });
  }

  public exportUsers(company: Company): void {
    this.companiesService.getUsersExport(company)
      .subscribe((response: Blob) => {
                FileSaver.saveAs(response, `Users_${company.name}.csv`);
              });
  }

  public filterCompanies(eventCompanies: Array<Company>): void {
    this.filteredCompanies = eventCompanies;
  }

  private prepareFieldsToSearch(): void {
    this.allCompanies.forEach((company: Company) => {
      this.fieldsToSearch.push([
        company.name.toLowerCase(),
      ]);
    });
  }

  public selectLeaderLinking(company, event): void {
    console.log(event);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/companies/companies.component.ts